
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import BestSellerSection from './components/BestSellerSection';
import BannerCarousel from './components/BannerCarousel';
import ProductGrid from './components/ProductGrid';
import FeatureSection from './components/FeatureSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white font-['Poppins']">
      <Navbar />
      <main>
        <HeroSection />
        <div className="max-w-[1200px] px-4 md:px-6 mx-auto">
          <CategorySection />
          <BestSellerSection />
          <BannerCarousel />
          <ProductGrid />
          <FeatureSection />
        </div>
      </main>
      <Footer />
    </div>
  );
}
